import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 pt-40 pb-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-14 h-14 mx-auto text-aura-muted mb-6" />
      <h1 className="font-serif text-3xl font-bold mb-3">Checkout cancelled</h1>
      <p className="text-aura-muted mb-8">No charge was made. Your bag is still saved.</p>
      <Link to="/cart" className="px-7 py-3 btn-accent rounded-full text-sm font-semibold">Return to bag</Link>
    </div>
  );
}
